import { IonIcon, IonSpinner } from '@ionic/react';
import { IconButton, ImageListItem, ImageListItemBar } from '@mui/material';
import { trashOutline } from 'ionicons/icons';
import { ReactElement, useCallback, useState } from 'react';
import { Attachment } from '../../api/graphql/generated';
import { ImageResolution } from '../../api/hooks/attachment.hooks';
import { AttachmentPreview } from '../attachment/attachment-preview';
import { WithConfirmation } from '../button/with-confirmation';
import './image.css';

interface ImagePreviewProps {
  attachment: Attachment;
  resolution?: ImageResolution;
  allowRemove?: boolean;
  onSelect?: () => void;
  onRemove?: () => void;
}

export const ImagePreview = (props: ImagePreviewProps): ReactElement => {
  const {
    attachment,
    resolution,
    allowRemove = false,
    onSelect,
    onRemove,
  } = props;

  const [isDeleting, setIsDeleting] = useState(false);

  const handleRemove = useCallback(async () => {
    setIsDeleting(true);
    if (typeof onRemove === 'function') {
      await onRemove();
    }
    setIsDeleting(false);
  }, [onRemove]);

  return isDeleting ? (
    <ImageListItem className="image-item-preview">
      <IonSpinner className="attachment-preview-spinner" />
    </ImageListItem>
  ) : (
    <ImageListItem
      key={attachment.id}
      className="image-item-preview"
      onClick={() => {
        if (onSelect) {
          onSelect();
        }
      }}
      title={attachment.name}
    >
      <AttachmentPreview
        attachment={attachment}
        resolution={resolution}
        isSmallPreview={true}
      />
      {allowRemove && typeof onRemove === 'function' && (
        <ImageListItemBar
          position="top"
          className="image-toolbar"
          sx={{ background: 'transparent' }}
          actionIcon={
            <WithConfirmation>
              {({ onConfirmed }) => {
                return (
                  <IconButton
                    className="remove-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      onConfirmed({ onConfirmation: handleRemove });
                    }}
                    disabled={isDeleting}
                  >
                    <IonIcon icon={trashOutline} color="danger" size="small" />
                  </IconButton>
                );
              }}
            </WithConfirmation>
          }
        />
      )}
    </ImageListItem>
  );
};
